<template>
    <SOSlotModal :modal-id="pageSetting.modalId" :modal-title="pageSetting.modalTitle" @close="close">
        <template v-slot:modal-body>
            <div class="p-d-16">
                <SOInputSelect
                    :required="true"
                    :title="'Di transfer dari akun'"
                    :selected="payload.idakun"
                    :placeholder="'Pilih akun'"
                    :options="options"
                    @option-selected="selectedAkun"
                />
                <ErrorMessage class="error" label="Akun" :validation="$v.payload.idakun" />
            </div>

            <div class="p-d-16">
                <SOInputDateTime
                    :required="true"
                    id="date-confirm-perminataan-outlet"
                    :title="'Waktu transfer'"
                    :max-date="getDateNow"
                    :value="$moment().format('DD/MM/YYYY HH:mm')"
                    @get-date="
                        (v) => {
                            payload.waktu = v;
                        }
                    "
                />
                <p class="m-d-0 f-12 f-c-midgrey f-regular">
                    Waktu digunakan sebagai acuan pencatatan di jurnal.
                </p>
                <ErrorMessage class="error" label="Waktu transfer" :validation="$v.payload.waktu" />
            </div>

            <div>
                <SOInputRegular
                    :title="'Catatan (Opsional)'"
                    :placeholder="'Catatan...'"
                    :value="''"
                    :validation="'alphanumeric'"
                    v-model="payload.catatan"
                />
            </div>
        </template>
        <template v-slot:modal-footer>
            <SOButton
                :text="'Setujui'"
                :primary="true"
                :full="true"
                :loading="pageSetting.btn.accept.loading"
                :disable="pageSetting.btn.accept.disabled"
                @action="setujui"
            />
        </template>
    </SOSlotModal>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "ModalPermintaanKasOutletSetujui",
    components: {
        SOSlotModal,
        ErrorMessage,
        SOInputSelect,
        SOInputDateTime,
        SOInputRegular,
        SOButton,
    },
    computed: {
        ...mapGetters("metaModule", {
            financialAccountFund: "getFinancialAccountFund",
        }),
        getDateNow() {
            return `${this.$moment().format("YYYY-MM-DD")}T23:59`;
        },
        getTotalSetoran() {
            return this.$route.query.totalSetoran;
        },
    },
    data() {
        return {
            pageSetting: {
                modalId: "modal-permintaan-kas-outlet-setujui",
                modalTitle: "Setujui Permintaan",
                btn: {
                    accept: {
                        loading: false,
                        disabled: false,
                    },
                },
            },
            options: [],
            payload: {
                idtransfer: "",
                idakun: "",
                waktu: "",
                catatan: "",
            },
            isNotification: false,
        };
    },
    validations: {
        payload: {
            idakun: {
                required,
            },
            waktu: {
                required,
            },
        },
    },
    mounted() {
        $("#" + this.pageSetting.modalId).modal("show");
        this.payload.idtransfer = this.$route.params.id;
        this.getFinancialAccountFund();
        this.isNotification = this.$route.params.isNotification
    },
    methods: {
        close() {
            $("#" + this.pageSetting.modalId).modal("hide");
            setTimeout(() => {
                this.$router.back();
            }, 300);
        },

        selectedAkun(value) {
            let selectedAkun = this.options.find((opt) => opt.id === value);
            if (selectedAkun.id) {
                this.payload.idakun = selectedAkun.id;
                if (selectedAkun.saldo < this.getTotalSetoran) {
                    this.$toast.error(`Saldo ${selectedAkun.text} tidak mencukupi`);
                }
            }
        },

        async getFinancialAccountFund() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchFinancialAccountFund");
            this.pageSetting.loading = false;
            if (res.success) {
                this.options = [];
                this.financialAccountFund.forEach((v) => {
                    this.options = [
                        ...this.options,
                        {
                            id: v.idakun,
                            text: v.nama_akun,
                            saldo: v.saldo_akhir,
                        },
                    ];
                });
            } else {
                this.$toast.error(res.err);
            }
        },

        errorValidation() {
            this.$v.payload.idakun.$touch();
            this.$v.payload.waktu.$touch();
            return this.$v.payload.idakun.$invalid || this.$v.payload.waktu.$invalid;
        },
        async setujui() {
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let selectedAkun = this.options.find((opt) => opt.id === this.payload.idakun);
            if (selectedAkun.id) {
                if (selectedAkun.saldo < this.getTotalSetoran) {
                    this.$toast.error(`Saldo ${selectedAkun.text} tidak mencukupi`);
                    return;
                }
            }

            this.pageSetting.btn.accept.loading = true;
            this.pageSetting.btn.accept.disabled = true;
            let form = new FormData();
            form.append("idtransfer", this.payload.idtransfer);
            form.append("status", 2);
            form.append("keterangan", this.payload.catatan);
            form.append("idakun_kredit", this.payload.idakun);
            form.append("waktu_transfer", this.$moment(this.payload.waktu).format("YYYY-MM-DD HH:mm:ss"));
            const res = await this.$store.dispatch("permintaanKasOutletModule/confirm", form);
            this.pageSetting.btn.accept.loading = false;
            this.pageSetting.btn.accept.disabled = false;
            if (!res.success) {
                this.$toast.error(res.err);
                return;
            }
            this.$toast.success(res.msg);
            await this.$store.commit("permintaanKasOutletModule/resetPermintaanKasOutlet");
            if (this.isNotification) {
                this.flutterNavigate('dashboard/notification')
                return
            }
            await this.$router.go(-2);
        },
    },
};
</script>
